export default __webpack_public_path__ + "static/media/SCA.3b9cda98.png";